























































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { Button, Icon } from '@/components/general'

// Models
import { Paginator } from '@/models'
import { BondControl } from '@/models/dailyControl'

// utils
import { dateLibs } from '@/utils'

export default defineComponent({
  name: 'BondControlTableList',
  components: {
    DataTable,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<BondControl[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const fields = [
      {
        key: 'year',
        sortable: false,
        label: 'Año'
      },
      {
        key: 'month',
        sortable: false,
        label: 'Mes'
      },
      {
        key: 'fortnight',
        sortable: false,
        label: 'Quincena'
      },
      {
        key: 'employee.fullName',
        sortable: true,
        label: 'Empleado'
      },
      {
        key: 'bondType.name',
        sortable: true,
        label: 'Tipo'
      },
      {
        key: 'amount',
        sortable: true,
        label: 'Importe Bono'
      },
      {
        key: 'observations',
        sortable: true,
        label: 'Observaciones'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '13%'
        }
      }
    ]

    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault

    return {
      fields,
      years,
      months,
      fortnights
    }
  }
})
